import React from 'react';
import ReactTooltip from "react-tooltip";
import {connect} from 'react-redux';
import moment from 'moment-timezone';
import gravatar from 'gravatar';
import {Link} from 'react-router';
import api from 'api';
import { withOpenC3Modal } from 'c3';
import MoneyFormat from '../components/MoneyFormat';
import DisplayLinks from '../components/DisplayLinks';
import {openModal} from '../actions/ModalActions';
import {markAsNotDuplicate, disableEmployee, reenableEmployee} from '../actions/ClientActions';
import MergeClientsModal from '../components/MergeClientsModal';
import MiddysStatusModal from '../components/MiddysStatusModal';
import AssignStaffMemberToClientModal from '../components/AssignStaffMemberToClientModal';
import ClientLogo from '../components/clients/ClientLogo';
import {Dropdown, DropdownItem} from '../components/bootstrap/Dropdown';
import {humanizeCamelCase, formatPhoneString} from '../utils/StringUtils';
import StaffMemberAssignedText from '../components/clients/StaffMemberAssignedText';
import ConfirmMarkAsDudModal from '../components/clients/ConfirmMarkAsDudModal';
import UnmarkAsDudModal from '../components/clients/UnmarkAsDudModal';
import MarkReferrerModal from '../components/clients/MarkReferrerModal';
import QualifyModal from '../components/clients/QualifyModal';
import MigrateBillingRegionModal from '../components/clients/MigrateBillingRegionModal';
import ClientStageModal from '../components/clients/ClientStageModal';
import ExtendTrialModal from '../components/clients/ExtendTrialModal';
import ChangeToTrialModal from '../components/clients/ChangeToTrialModal';
import ClockForTimezone from '../components/ClockForTimezone';
import GoogleStaticMap from '../components/GoogleStaticMap';
import LockStatusModal from '../components/clients/LockStatusModal';
import UpdateDiscountModal from '../components/clients/UpdateDiscountModal';
import ConfirmDeleteContactModal from '../components/clients/ConfirmDeleteContactModal';
import ClientStatusLabel from '../components/ClientStatusLabel';
import TagsModal from '../components/TagsModal';
import { getStageFromId } from '../constants/clientStages';
import ContactForm from './contact-form/ContactForm';
import ConfirmationModal from './ConfirmationModal';
import EmployeeImage from './clients/EmployeeImage';
import ScoreBreakDownModal from './clients/ScoreBreakDownModal';
import CreditModal from './clients/CreditModal';
import FreePlanModal from "./clients/FreePlanModal";
import ConfirmDisableEmployeeModal from './clients/ConfirmDisableEmployeeModal';
import ConfirmReenableEmployeeModal from './clients/ConfirmReenableEmployeeModal';
import ChangeEssentialsAndProTrialPlanModal from './clients/ChangeEssentialsAndProTrialPlanModal';

@connect(
    state => ({
        canLoginAsFergusUsers: state.auth.user.permissions.includes('LOGIN_AS_FERGUS_USER'),
        canManageCredit: state.auth.user.permissions.includes('MANAGE_CREDIT'),
        canManageLockStatus: state.auth.user.permissions.includes('MANAGE_CREDIT'),
        canManageDiscount: state.auth.user.permissions.includes('MANAGE_CREDIT'),
        canMigrateBillingRegions: state.auth.user.permissions.includes('MANAGE_BILLING'),
        secondaryBackgroundColour: state.theme.selected.secondaryBackground.value,
        secondaryBackgroundTextColour: state.theme.selected.secondaryBackground.text
    }),
    {openModal, markAsNotDuplicate, disableEmployee, reenableEmployee}
)
@withOpenC3Modal
export default class ClientSidePane extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            showBanned : false
        };
    }

    showBannedClick(e){
        e.preventDefault();
        this.setState({
            showBanned : ! this.state.showBanned
        })
    }

    showMergeModal() {
        this.props.openModal(MergeClientsModal, {client: this.props.client, staff: this.props.staff});
    }

    showMarkAsDudModal() {
        this.props.openModal(ConfirmMarkAsDudModal, {client: this.props.client});
    }

    showUnmarkAsDudModal() {
        this.props.openModal(UnmarkAsDudModal, {client: this.props.client});
    }

    showReferralModal() {
        this.props.openModal(MarkReferrerModal, {client: this.props.client});
    }

    showCreateContactModal(e) {
        e.preventDefault();
        this.props.openc3Modal(
            <ContactForm clientId={this.props.client.id} />,
            {title: 'Add contact', icon: 'user-add-2'}
        );
    }

    showOnboardingModal() {
        var { client } = this.props;

        this.props.openc3Modal(
            <ConfirmationModal
                action="post"
                actionUrl={`clients/${client.id}/mark_self_onboarding`}
                isDanger={false}
            >
                <p>Mark <b>{client.name}</b> as self onboarding?</p>
            </ConfirmationModal>
        );
    }

    editContact(contact) {
        this.props.openc3Modal(
            <ContactForm clientId={this.props.client.id} {...contact} />,
            {title: 'Update contact', icon: 'user-add-2'}
        );
    }

    handleAssignedStaffEdit(e) {
        e.preventDefault();
        this.props.openModal(AssignStaffMemberToClientModal, {client: this.props.client, onlyOneAssign: true});
    }

    showQualifyModal(){
        this.props.openModal(QualifyModal, {client: this.props.client});
    }

    showMigrateBillingRegionModal(){
        this.props.openModal(MigrateBillingRegionModal, {client: this.props.client});
    }

    showLockStatusModal(){
        this.props.openModal(LockStatusModal, {client: this.props.client});
    }

    showUpdateDiscountModal(){
        this.props.openModal(UpdateDiscountModal, {client: this.props.client});
    }

    showFreePlanModal(){
        this.props.openModal(FreePlanModal, {client: this.props.client});
    }

    showChangeTrialPlanModal(){
        this.props.openModal(ChangeEssentialsAndProTrialPlanModal, {client: this.props.client});
    }

    showCreditModal() {
        this.props.openModal(CreditModal, {client: this.props.client});
    }

    showClientStageModal(){
        var client = this.props.client;
        client.stageName = getStageFromId(client.clientStageId);

        this.props.openModal(ClientStageModal, { client: client });
    }

    extendTrialModal(e){
        e.preventDefault();
        this.props.openModal(ExtendTrialModal, {client: this.props.client});
    }

    changeToTrialModal(e) {
        e.preventDefault();
        this.props.openModal(ChangeToTrialModal, {client: this.props.client});
    }

    deleteContact(contact) {
        this.props.openModal(ConfirmDeleteContactModal, {contact});
    }

    showScoreBreakDown(){
        this.props.openModal(ScoreBreakDownModal, {client: this.props.client});
    }
    toggleIsMiddys() {
        this.props.openModal(MiddysStatusModal, {clients: this.props.client});
    }
    markAsNotDuplicate(clientId2) {
        this.props.markAsNotDuplicate(this.props.client.id, clientId2);
    }
    disableEmployee(user) {
        this.props.openModal(ConfirmDisableEmployeeModal, {client: this.props.client, user:user});
    }
    reenableEmployee(user) {
        this.props.openModal(ConfirmReenableEmployeeModal, {client: this.props.client, user:user});
    }
    editTags(e) {
        e.preventDefault();
        this.props.openModal(TagsModal, {client: this.props.client});
    }
    async loginAsPartnerAdvisor(e) {
        e.preventDefault();
        var authUrl = await api.post(`login-as-advisor`, {
            clientId: this.props.client.id,
            employeeId: this.props.client.advisorAccess
        });
        window.open(authUrl.value);
    }
    async loginAsFgAdvisor(employeeId, e) {
        e.preventDefault();
        var authUrl = await api.post(`login-as-advisor`, {
            clientId: this.props.client.id,
            employeeId
        });
        window.open(authUrl.value);
    }
    renderLastContactedLabel(c) {
        if(c.id == this.props.client.lastContactedId) {
            return (
                <label className="label label-success">Last contacted</label>
            );
        }

        return null;
    }
    render() {
        var {client, canLoginAsFergusUsers, canManageCredit, canManageLockStatus, canManageDiscount, canMigrateBillingRegions, secondaryBackgroundColour, secondaryBackgroundTextColour} = this.props;

        client.stageName = getStageFromId(client.clientStageId);
        client.bannedUsers = client.users.filter(user => {return user.banned});
        client.activeUsers = client.users.filter(user => {
            return ! user.banned && user.userType != 'Partner'
        });

        var staffNumbers = client.activeUsers.length;

        var contacts = this.props.contacts.filter(c => c.contactType != 'COMP');

        var statsArray = [];
        Object.keys(client.stats).forEach(key => {
            var val = client.stats[key];
            if (typeof val == 'boolean')
            {
                val = val ? <span style={{color : 'green'}}>Yes</span> : <span style={{color : 'red'}}>No</span>;
            }
            statsArray.push({
                key : humanizeCamelCase(key),
                value : val
            })
        });

        //@TODO remove this calculation, use the model method $client->leadValue()
        var largestUsers = staffNumbers;
        if (this.props.client.numberOfStaff && this.props.client.numberOfStaff > staffNumbers)
        {
            largestUsers = this.props.client.numberOfStaff;
        }

        var leadValue = largestUsers * 40; //40 = Average Revenue Per User / month

        return (
            <div className="fade-in">
                <div className="panel panel-default" style={{background: secondaryBackgroundColour, color: secondaryBackgroundTextColour}}>
                    <div className="panel-body client-side-pane">
                        {client.isDud && !client.mergedToClientId  &&
                            <div className="alert alert-danger close-off-alert"><h2><i className="fa fa-warning">
                                </i> This Client has been deleted</h2>
                                <p><strong>Close off note:</strong> {client.closeOffNotes}</p>
                                <p><strong>Close off reasons:</strong></p>
                                <ul>
                                    {client.closeOffReasons.map(reason => <li key={reason.id}>{reason.reason}</li>)}
                                </ul>
                                <button onClick={this.showUnmarkAsDudModal.bind(this)} className="btn btn-success"><i className="fa fa-check"></i> Restore Client</button>
                            </div>
                        }
                        {client.isDud && client.mergedToClientId  && <ClientMergedTo />}
                        {largestUsers === 1 && this.props.client.numberOfStaff === 1 &&
                            <div className="alert alert-danger"><h2><i className="fa fa-warning">
                                </i> This Client is a one man band</h2>
                                <button onClick={this.showQualifyModal.bind(this)} className="btn btn-success"><i className="fa fa-check"></i> Change</button>
                            </div>
                        }
                        { this.props.duplicates && this.props.duplicates.length > 0 &&
                            <div className="alert alert-danger">
                                <h4><i className="fa fa-warning"></i> Duplicate?</h4>
                                <ul style={{fontSize : '0.9em'}}>
                                {this.props.duplicates.map((dupe, i) =>
                                    <li key={i}>
                                        <a target="_blank" href={"/clients/" + dupe.id} style={{marginRight: '10px'}}>{dupe.name}</a>
                                        <i title="Mark as not a duplicate" onClick={this.markAsNotDuplicate.bind(this, dupe.id)} className="fa fa-times"></i>
                                    </li>
                                )}
                                </ul>
                            </div>
                        }
                        <div className="text-center" style={{overflow : 'hidden'}}>
                            <ClientLogo client={client} />
                        </div>

                        <h2 className="text-center"><span className="clientId">#{client.publicId}</span> <strong>{client.name}</strong></h2>

                        <div className="text-center">Fergus Id: {client.fergusId}</div>
                        {client.fergusCompanyId &&
                            <div className="text-center">Company Id: {client.fergusCompanyId}</div>
                        }
                        {client.salesforceLink &&
                            <div className="text-center">
                                <a href={client.salesforceLink} target={"_blank"}>
                                    Open Account in Salesforce
                                </a>
                            </div>
                        }
                        {client.hubspotLink &&
                            <div className="text-center">
                                <a href={client.hubspotLink} target={"_blank"}>
                                    Open Company in HubSpot
                                </a>
                            </div>
                        }
                        {client.stripeConnectedAccountId &&
                            <div className="text-center" style={{fontSize : '0.9em'}}>Stripe:{' '}
                                <a href={`https://dashboard.stripe.com/connect/accounts/${client.stripeConnectedAccountId}`} target={"_blank"} data-tip="Switch to the correct Stripe account first">
                                    {client.stripeConnectedAccountId}
                                </a>
                            </div>
                        }

                        <div className="row">
                            <Dropdown iconName="cog" className="col-xs-2">
                                <DropdownItem onClick={this.showMergeModal.bind(this)}>
                                    <i className="fa fa-undo"></i> Merge
                                </DropdownItem>
                                <DropdownItem onClick={this.showQualifyModal.bind(this)}>
                                    <i className="fa fa-globe"></i> Qualify
                                </DropdownItem>
                                {canManageCredit &&
                                    <DropdownItem onClick={this.showCreditModal.bind(this)}>
                                        <i className="fa fa-money"></i> Manage Credit
                                    </DropdownItem>
                                }
                                {!client.isDud && !client.isPaying &&
                                    <DropdownItem onClick={this.showMarkAsDudModal.bind(this)}>
                                        <i className="fa fa-remove"></i> Mark as Dud
                                    </DropdownItem>
                                }
                                {client.isDud &&
                                    <DropdownItem onClick={this.showUnmarkAsDudModal.bind(this)}>
                                        <i className="fa fa-check"></i> Unmark as Dud
                                    </DropdownItem>
                                }
                                {client.fergusId &&
                                    <DropdownItem onClick={this.showReferralModal.bind(this)}><i className="fa fa-dollar"></i> Mark as being referred</DropdownItem>
                                }
                                {!client.isPaying &&
                                    <DropdownItem onClick={this.showOnboardingModal.bind(this)}><i className="fa fa-certificate"></i> Mark as self onboarding</DropdownItem>
                                }

                                <DropdownItem onClick={this.toggleIsMiddys.bind(this)}><i className="fa fa-toggle-on"></i> Middys Status</DropdownItem>
                            </Dropdown>
                            <h4 className="text-center col-xs-10">
                                <i className="fa fa-user"></i>
                                <StaffMemberAssignedText assignedStaffMember={this.props.staff.find(u => u.id == client.assignedUserIds)} />
                                <small>(<a href="#" onClick={this.handleAssignedStaffEdit.bind(this)}>edit</a>)</small>
                            </h4>
                        </div>

                        {client.advisorAccess &&
                            <div className="row" style={{marginTop: 15, paddingLeft: 15}}>
                                <a onClick={this.loginAsPartnerAdvisor.bind(this)}
                                   className="btn btn-success btn-block">
                                    Login as advisor <i className="fa fa-sign-in"></i>
                                </a>
                            </div>
                        }

                        { client.shortAddress &&
                            <div style={{textAlign: 'center'}}>
                                <h4 data-tip={client.fullAddress} className="text-center"><small><i className="fa fa-map-marker"></i> { client.shortAddress}</small></h4>
                                <div style={{overflow: 'hidden'}}>
                                    <GoogleStaticMap address={client.shortAddress.replace(' ', ',')} fullAddress={client.fullAddress} />
                                </div>
                            </div>
                        }

                        <hr />

                        <div className="row text-center">
                            <div className="col-xs-4">
                                <div><strong>
                                    {client.score && client.fergusId &&
                                        <a onClick={this.showScoreBreakDown.bind(this)}>
                                            {client.score}
                                        </a>
                                    }
                                    {client.score && ! client.fergusId &&
                                        <span>
                                            {client.score}
                                        </span>
                                    }
                                    {! client.score &&
                                        <span>N/A</span>
                                    }
                                    </strong></div>
                                <div><small>Score</small></div>
                            </div>
                            <div className="col-xs-4">
                                <div>
                                    <strong>
                                        <MoneyFormat value={client.cmrr} currency={client.billingRegion.currency} />
                                    </strong>
                                </div>
                                <div>
                                    <small>CMRR</small>
                                </div>
                            </div>
                            <div className="col-xs-4">
                                <ReactTooltip  place='top' type='dark' effect='solid'/>
                                <div data-tip="Active Users / Reported Users"><strong><a onClick={this.showQualifyModal.bind(this)}>{staffNumbers}{staffNumbers != largestUsers ? '/' + largestUsers : ''}</a></strong></div>

                                <div><small>{this.props.client.numberOfStaff ? 'Active Users/Users' : ''}</small></div>
                            </div>
                        </div>
                        <hr/>
                        <ul className="profile-details">
                            <li>
                                <div className="profile-label"><i className="fa fa-truck"></i><strong> Stage:</strong></div>
                                {client.stageName}
                            </li>
                            <li>
                                <div className="profile-label"><i className="fa fa-question-circle"></i><strong> Interest Level:</strong></div>
                                {client.interestLevel.name}
                            </li>
                            {client.interestNotes &&
                                <li>
                                    <div className="profile-label"><i className="fa fa-comment"></i><strong> Interest Notes:</strong></div>
                                    {client.interestNotes}
                                </li>
                            }
                            {client.plannedGoLiveDate &&
                                <li>
                                    <div className="profile-label"><i className="fa fa-calendar"></i><strong> Go live date:</strong></div>
                                    {moment(client.plannedGoLiveDate).format('MMMM Do YYYY')}
                                </li>
                            }
                            <li>
                                <div className="profile-label">
                                    <i className="fa fa-calendar"></i>
                                    <strong>Status:</strong>
                                </div>
                                <ClientStatusLabel status={client.status} />
                                 {!! client.isMiddy &&
                                    <span style={{background: 'pink', marginLeft: 10}} className={"label label-default"}>Middys</span>
                                }
                                {
                                    client.trialExpired &&
                                    <button className="pull-right btn-xs btn-info" data-tip="Change to Trial" onClick={this.changeToTrialModal.bind(this)}>Change to Trial</button>
                                }
                            </li>
                            {
                                (client.canChangeEssentialsAndProPlan || client.availablePlansToChangeFromLegacy.length !== 0) &&
                                <li>
                                    <div className="profile-label">
                                        <i className="fa fa-money"/><strong> Change Plan:</strong>
                                    </div>
                                    {client.currentPlan.label}
                                    <a className="btn btn-mini" style={{padding : '0', marginLeft: 5}} onClick={this.showChangeTrialPlanModal.bind(this)}><i className="fa fa-pencil"/></a>
                                </li>
                            }
                            <li>
                                <div className="profile-label">
                                    <i className="fa fa-calendar"></i>
                                    <strong>Tags:</strong>
                                </div>
                                {client.tags.map(tag =>
                                    <span key={tag.id} className="label label-default" style={{marginRight: 5}}>{tag.name}</span>
                                )}

                                <a className="btn btn-mini" style={{padding : '0'}} onClick={this.editTags.bind(this)}><i className="fa fa-pencil"></i></a>
                            </li>

                            <li>
                                <div className="profile-label">
                                    <i className="fa fa-calendar"></i>
                                    <strong>Lead Value:</strong>
                                </div>
                                <MoneyFormat value={leadValue} currency={client.billingRegion.currency}/>
                            </li>
                            { client.timezone &&
                                <li>
                                    <div className="profile-label">
                                        <i className="fa fa-calendar"></i>
                                        <strong>Local Time:</strong>
                                    </div>
                                    <ClockForTimezone timezone={client.timezone} /> ({client.timezone})

                                </li>
                            }
                            <li>
                                <div className="profile-label">
                                    <i className="fa fa-calendar"></i>
                                    <strong>{client.signedUpAt ? 'Signed up:' : 'Created:'}</strong>
                                </div>
                                {client.signedUpAt ?  moment(client.signedUpAt).format('MMMM Do YYYY') : moment(client.createdAt).format('MMMM Do YYYY')}
                            </li>

                            {client.convertedAt &&
                                <li>
                                    <div className="profile-label">
                                        <i className="fa fa-calendar"></i>
                                        <strong>Started Paying: </strong>
                                    </div>
                                    {moment(client.convertedAt).format('MMMM Do YYYY')}
                                </li>
                            }
                            { client.currentPlan &&
                                <li>
                                    <div className="profile-label">
                                        <i className="fa fa-money"/><strong> Current Plan:</strong>
                                    </div>
                                    {client.currentPlan.label}
                                </li>
                            }
                            { client.trialExpiresAt &&
                                <li>
                                    <div className="profile-label">
                                        <i className="fa fa-calendar"></i>
                                        <strong>Trial Expires</strong>
                                    </div>
                                    {moment(client.trialExpiresAt).format('MMMM Do YYYY')}

                                    {client.companyOnTrial &&
                                        <button className="pull-right btn-xs btn-info" data-tip="Change When The Trial Ends" onClick={this.extendTrialModal.bind(this)}>Change Trial End</button>
                                    }
                                </li>
                            }
                            <li>
                                <div className="profile-label"><i className="fa fa-truck"></i><strong> Industry:</strong></div>
                                {client.industryName ? client.industryName : "Not set"}
                                <a className="btn btn-mini" style={{padding : '0', marginLeft: 5}} onClick={this.showQualifyModal.bind(this)}><i className="fa fa-pencil"></i></a>
                            </li>
                            <li>
                                <div className="profile-label"><i className="fa fa-flickr"></i><strong> Billing Region:</strong></div>
                                {client.billingRegion ? client.billingRegion.name : "Not Available"}
                                {canMigrateBillingRegions &&
                                    <a className="btn btn-mini"
                                        style={{padding : '0', marginLeft: 5}}
                                        onClick={this.showMigrateBillingRegionModal.bind(this)}
                                    >
                                        <i className="fa fa-pencil"></i>
                                    </a>
                                }
                            </li>
                            <li>
                                <div className="profile-label"><i className="fa fa-flickr"></i><strong> Lock Status:</strong></div>
                                {client.lockStatus ? client.lockStatus : "Not Available"}
                                { canManageLockStatus &&
                                <a className="btn btn-mini" style={{padding : '0', marginLeft: 5}} onClick={this.showLockStatusModal.bind(this)}>
                                    <i className="fa fa-pencil"></i>
                                </a>
                                }
                            </li>
                            <li>
                                <div className="profile-label"><i className="fa fa-money"></i><strong> Discount:</strong></div>
                                { (client.discount || client.discount === 0) ? client.discount : "Not Available"}
                                { canManageDiscount &&
                                <a className="btn btn-mini" style={{padding : '0', marginLeft: 5}} onClick={this.showUpdateDiscountModal.bind(this)}>
                                    <i className="fa fa-pencil"></i>
                                </a>
                                }
                            </li>
                            <li>
                                    <div className="profile-label">
                                    <i className="fa fa-money"/><strong> Free Plan:</strong>
                                    </div>
                                    {client.currentFreePlan.label}
                                    <a className="btn btn-mini" style={{padding : '0', marginLeft: 5}} onClick={this.showFreePlanModal.bind(this)}><i className="fa fa-pencil"/></a>

                            </li>
                            {client.meta && client.meta.accountingSoftware &&
                                <li>
                                    <div className="profile-label"><i className="fa fa-dollar"></i><strong> Accounting:</strong></div>
                                    {client.meta.accountingSoftware}
                                </li>
                            }
                            {client.meta && client.meta.blockers &&
                                <li>
                                    <div className="profile-label"><i className="fa fa-dollar"></i><strong> Blockers:</strong></div>
                                    {client.meta.blockers}
                                </li>
                            }
                            {client.meta && client.meta.currentSystem &&
                                <li>
                                    <div className="profile-label"><i className="fa fa-inbox"></i><strong> Old System:</strong></div>
                                    {client.meta.currentSystem}
                                </li>
                            }

                        </ul>

                        <h4 style={{marginBottom: '15px'}}><strong>Contact Information</strong></h4>

                        <ul className="profile-details">
                            <li>
                                <div className="profile-label"><i className="fa fa-phone"></i> <strong>Phone:</strong></div>
                                <DisplayLinks className="profile-value largerPhone" values={client.phoneNumbers} type="tel" style={{position : 'relative', 'top' : '-5px'}} />

                            </li>
                            { client.websiteUrl &&
                                <li>
                                    <div className="profile-label"><i className="fa fa-link"></i> <strong>Web:</strong></div>
                                    <DisplayLinks className="profile-value"  values={[client.websiteUrl]} type="href" />
                                </li>
                            }
                            { client.emailAddresses.length > 0 &&
                                <li>
                                    <div className="profile-label"><i className="fa fa-envelope"></i> <strong>E-mail:</strong></div>
                                    <DisplayLinks className="profile-value" values={client.emailAddresses} type="mailto" />

                                </li>
                            }
                            { client.fullAddress.length > 0 &&
                                <li>
                                    <div className="profile-label"><i className="fa fa-map-marker"></i> <strong>Address:</strong></div>
                                    <div className="profile-value">
                                        {client.fullAddress}
                                    </div>
                                </li>
                            }
                        </ul>
                    </div>
                </div>

                <div className="panel panel-default" style={{background: secondaryBackgroundColour, color: secondaryBackgroundTextColour}}>
                    <div className="panel-heading">
                        <div className="pull-right">
                            <a style={{paddingTop: '2px', paddingBottom: '2px'}} href="#" onClick={this.showCreateContactModal.bind(this)} className="btn btn-success">
                                + Contact
                            </a>
                        </div>
                        <h2>Contacts</h2>
                    </div>
                    <div className="panel-body no-padding">
                        {! contacts.length &&
                            <p className="m-15">No contacts</p>
                        }
                        <ul className="users-list">
                            {contacts.map(c => {
                                return (
                                    <li key={c.id}>
                                        <a href="#">
                                            <img className="avatar"
                                                src={c.emails.length > 0 ? gravatar.url(c.emails[0]['email'], {s: 80, d: 'retro'}, true) : 'https://www.gravatar.com/avatar/00000000000000000000000000000000?d=mm&f=y'} />
                                        </a>
                                        <div className="name">
                                            {`${c.firstName} ${c.lastName}`} {this.renderLastContactedLabel(c)}
                                            <div className="pull-right">
                                                <i onClick={this.editContact.bind(this, c)} className="fa fa-pencil cursor-pointer pr5"></i>
                                                <i onClick={this.deleteContact.bind(this, c)} className="fa fa-times cursor-pointer pr5"></i>
                                            </div>
                                        </div>
                                        <div className="job">
                                            <i className="fa fa-briefcase"></i>{c.description}
                                        </div>
                                        <div>
                                        {c.emails.length > 0 &&
                                            <span>
                                                <i className="fa fa-envelope-o pr5"></i>
                                                {c.emails.map((e,i) =>
                                                    <a key={i} href={`mailto:${e.email}`} className="mr5">{e.email}</a>
                                                )}
                                            </span>
                                        }
                                        {c.numbers.length > 0 &&
                                            <span>
                                                <i className="fa fa-phone pr5"></i>
                                                {c.numbers.map((e,i) =>
                                                     <a key={i} href={`tel:${e.number}`} className="mr5 largerPhone">{formatPhoneString(e.number)}</a>
                                                )}
                                            </span>
                                        }
                                        {c.skypeUsername &&
                                            <div>
                                                <i className="fa fa-skype"></i> {c.skypeUsername}
                                            </div>
                                        }
                                        </div>
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                </div>
                <div className="panel panel-default" style={{background: secondaryBackgroundColour, color: secondaryBackgroundTextColour}}>
                    <div className="panel-heading">
                        <h2>Fergus Users</h2>
                    </div>
                    <div className="panel-body no-padding">
                        {client.activeUsers && !client.activeUsers.length &&
                            <p className="m-15">No users</p>
                        }
                        <ul className="users-list">
                            { client.activeUsers && client.activeUsers.map((user) => {
                                return (
                                    <li key={user.employeeId}>
                                        { canLoginAsFergusUsers &&
                                            <div>
                                                <a
                                                    onClick={this.disableEmployee.bind(this, user)}
                                                    className="btn btn-danger pull-right">
                                                    Disable employee <i className="fa fa-lock"></i>
                                                </a>

                                                <a
                                                    onClick={this.loginAsFgAdvisor.bind(this, user.employeeId)}
                                                    className="btn btn-success pull-right">
                                                    Login as advisor <i className="fa fa-sign-in"></i>
                                                </a>
                                            </div>
                                        }
                                        <a target="_blank" href={"https://fergusapp.com/auth/login?prefill_email=" + user.email.replace('@', '%40')}>
                                            <EmployeeImage guid={user.guid} />
                                        </a>
                                        <div className="name">{user.name}</div>
                                        <span className="job"><i className="fa fa-briefcase"></i> {user.userType}</span>
                                        <span className="job">{user.title} <i className="fa fa-envelope-o"></i> <a href={`mailto:${user.email}`}>{user.email}</a></span>
                                        <span>Last Access:
                                            {! user.lastLogin && <em>Unknown</em> }
                                            {user.lastLogin &&  <em>{moment(user.lastLogin).fromNow()} </em> }
                                        </span>
                                    </li>
                                )
                            })}
                        </ul>
                        { client.bannedUsers && client.bannedUsers.length > 0 &&

                        <div className="text-center">
                            <a onClick={this.showBannedClick.bind(this)} href="">
                                {this.state.showBanned ? "Hide" : "Show"} {client.bannedUsers.length} Disabled Users
                            </a>
                        </div>
                        }
                        <ul className="users-list" style={{display : this.state.showBanned ? "block" : "none"}}>

                            { client.bannedUsers && client.bannedUsers.map((user) =>
                                <li key={user.employeeId} style={{opacity : "0.6"}}>
                                    <a target="_blank" href={"https://fergusapp.com/auth/login?prefill_email=" + user.email.replace('@', '%40')}>
                                        <img className="avatar" src={`${__FG_COMPANY_IMAGES_HOST__}index.php/ext/employee_avatar/${user.guid}`} />
                                    </a>
                                    <div className="name">{user.name}
                                    { canLoginAsFergusUsers &&
                                        <a
                                            onClick={this.reenableEmployee.bind(this, user)}
                                            className="btn btn-warning pull-right">
                                            Reenable employee <i className="fa fa-unlock"></i>
                                        </a>
                                    }
                                    </div>
                                    <span className="job"><i className="fa fa-briefcase"></i>{user.email}</span>
                                    <span>Last Access:
                                        {! user.lastLogin && <em>Unknown</em> }
                                        {user.lastLogin &&  <em>{moment(user.lastLogin).fromNow()} </em> }
                                    </span>
                                </li>
                            )}

                        </ul>
                    </div>
                </div>
                {statsArray &&
                    <div className="panel panel-default" style={{background: secondaryBackgroundColour, color: secondaryBackgroundTextColour}}>
                        <div className="panel-heading">
                            <h2>Company Info</h2>
                        </div>
                        <div className="panel-body no-padding">

                            <table className="table table-condensed">
                                <tbody>
                                    { statsArray.map( stat => {
                                        return (
                                            <tr key={'stat' + stat.key}>
                                                <th>{stat.key}</th><td>  {stat.value}</td>
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </div>
                }
            </div>
        );
    }
}


@connect(
        state => ({
            events: state.activeClient.events,
            client: state.activeClient.client
        })
)
class ClientMergedTo extends React.Component {
    render() {

        var {client} = this.props;
        var mergedEvent = this.props.events.find(e => e.activityType == "CLIENT_MERGED_FROM");
        return (
            <div className="alert alert-danger close-off-alert"><h2><i className="fa fa-warning">
            </i> This Client has been merged</h2>
                <Link to={`/clients/${client.mergedToClientId}`}>
                    <p>{mergedEvent && mergedEvent.name}</p>
                </Link>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./app/components/ClientSidePane.js